import { ErrorMessage } from "@hookform/error-message";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { notify } from "../../utils";
import { NotifyType } from "../../utils/app-config";
import { useConfig } from "../../context/ConfigProvider";
import { ILocalUser } from "../../typings/models/LocalUser";
import Contaier from "../../components/layout/Container/Container";
import { useCookies } from "react-cookie";
import Loader from "../../components/molecules/Loader";
import { encryptData, decryptData } from "../../utils/encryptionhelper";

function Auth() {
  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ILocalUser>();
  const [loading, setLoading] = useState(false);
  const { message } = notify();
  const cfg = useConfig();
  const authUser: string = cfg.REACT_APP_AUTH_USER ?? "";
  const authSecret: string = cfg.REACT_APP_AUTH_SECRET ?? "";

  const [cookies, setCookie] = useCookies(["authtoken"]);
  // Only redirect if the cookie decrypts to a valid user id
  try {
    const userId = decryptData(cookies["authtoken"]);
    if (userId) {
      window.location.href = "/eservices/";
    }
  } catch (e) {
    // ignore and allow login form to appear
  }

  const onClickLogin = async () => {
    setLoading(false);
    handleSubmit(async (userModel: ILocalUser) => {
      setLoading(false);
      if (userModel.UserId == authUser && userModel.Password == authSecret) {
        const token = encryptData(authUser);
        setCookie("authtoken", token, { 
          maxAge: 86400,
          secure: true,
          sameSite: 'strict',
          path: '/eservices'
        });
        window.location.href = "/eservices/";
      } else {
        message(NotifyType.Error, "User Login Failed");
      }
    })();
  };

  return (
    <>
      <Contaier>
        <div className="inner-bx">          
          <div className="container">
            <div className="row py-5">
              <div className="col-lg-3"></div>
              <div className="col-lg-6">
                <div className="row m-0 justify-content-center justify-content-lg-end">
                  <div className="col-sm-10  col-md-6 col-lg-9">
                    <div className="login-wrapper">
                      <h1>Login ID</h1>
                      <p>Login to E-Services</p>
                      <div>
                        <div className="form-group mb-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Username"
                            id="UserId"
                            {...register("UserId", {
                              required: "Please enter Username",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="UserId"
                            render={({ message }) => (
                              <p className="errorMsg">{message}</p>
                            )}
                          />
                        </div>
                        <div className="form-group mb-3">
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Password"
                            id="Password"
                            {...register("Password", {
                              required: "Please enter Password",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="Password"
                            render={({ message }) => (
                              <p className="errorMsg">{message}</p>
                            )}
                          />
                        </div>
                        <button
                          className="btn btn-primary mb-3 w-75"
                          onClick={onClickLogin}
                          type="button"
                          disabled={loading}
                        >
                          {loading ? <Loader /> : <>Login</>}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Contaier>
    </>
  );
}

export default Auth;
